import { render, staticRenderFns } from "./CreateBillingDO.vue?vue&type=template&id=52e39c48"
import script from "./CreateBillingDO.vue?vue&type=script&lang=js"
export * from "./CreateBillingDO.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports